import { Link, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react"
import axios from "axios";
import {Eleccostlistapi, api, Eleccostdelete} from '../../../apis/urls'
import Loader from '../../../common-components/loader'
import ReactPaginate from 'react-paginate';
import { $ } from "react-jquery-plugin";

const ElecostList =()=> {

    const [result, setResult] = useState('')
    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        setTimeout(() => {
            Listing();
            });
    }, []);


    const Listing = () => {
        
    let token = "Bearer "+localStorage.getItem('token');

        const instance = axios.create({
            baseURL: `${Eleccostlistapi}/1`,
            timeout: 1000000,
            headers: {'authorization': token}
        });

        instance.get('').then(res => {

            if(res.data.message === "Success"){            
                setResult(res.data.data);
            }
        });
    }

 
    let sl =1;
    return(
        <div>
        <aside class="right-side areas">
			<div class="content-area dash-contentss">
                <div class="page-title-wrpr">
                    <div class="page-title-left-column">
                        <i class="icon-library1"></i>
                        <h2 class="page-title"> Electricity Cost List</h2>
                    </div>
                </div>
             
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                <li class="breadcrumb-item active" aria-current="page">Electricity Cost List</li>
              </ol>
            </nav>



            <div class="faculty-list-wrpr list-wrpr">
                <div class="list faculty">
                    <div class="row">
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="date-wrpr">{sl++}</span>
                                <span class="desig">Sl.No</span>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="update-date">
                                <span class="desig">${result.electricty_cost}</span>
                                <span class="date-wrpr">Cost</span>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <div class="update-date">
                                <span class="desig">{result.status}</span>
                                <span class="date-wrpr">Status</span>
                                
                            </div>
                        </div>
                        
                        <div class="col-md-2">
                            <div class="list-action-wrpr text-right roundicons-text">
                                <Link  to={"/edit_elecost/"+1} data-toggle="tooltip" title="Edit"  ><i class="edit icon-pencil3"></i><span>Update</span></Link>
                            </div>
                        </div>

                    </div>

                    
                </div>
   
     
            </div>    
   
        </div>
        </aside>
    </div>
    );
}

export default ElecostList;


